/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { errorResponseSchema } from "./errorResponseSchema.ts";
import { unauthorizedSchema } from "./unauthorizedSchema.ts";

export const userDeleteRequestOtpCreateStatus200Schema = z.any();

export const userDeleteRequestOtpCreateStatus400Schema = errorResponseSchema;

export const userDeleteRequestOtpCreateStatus401Schema = unauthorizedSchema.describe("Сериализатор 401 ошибки - для документации.");

export const userDeleteRequestOtpCreateResponseSchema = z.union([
	userDeleteRequestOtpCreateStatus200Schema,
	userDeleteRequestOtpCreateStatus400Schema,
	userDeleteRequestOtpCreateStatus401Schema,
]);
